import { render, staticRenderFns } from "./AvailabilitySlot.vue?vue&type=template&id=20cf9073&scoped=true"
import script from "./AvailabilitySlot.vue?vue&type=script&lang=js"
export * from "./AvailabilitySlot.vue?vue&type=script&lang=js"
import style0 from "./AvailabilitySlot.vue?vue&type=style&index=0&id=20cf9073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf9073",
  null
  
)

export default component.exports